// Generated by Ignite ignite.com/cli

import { SigningStargateClient, DeliverTxResponse, StdFee } from "@cosmjs/stargate";
import { EncodeObject, GeneratedType, OfflineSigner, Registry } from "@cosmjs/proto-signing";
import { msgTypes } from './registry';
import { IgniteClient } from "../client"
import { MissingWalletError } from "../helpers"
import { Api } from "./rest";
import { MsgSendPacket } from "./types/ibc/core/channel/v2/tx";
import { MsgRecvPacket } from "./types/ibc/core/channel/v2/tx";
import { MsgTimeout } from "./types/ibc/core/channel/v2/tx";
import { MsgAcknowledgement } from "./types/ibc/core/channel/v2/tx";

import { PacketState as typePacketState} from "./types"
import { PacketSequence as typePacketSequence} from "./types"
import { Packet as typePacket} from "./types"
import { Payload as typePayload} from "./types"
import { Acknowledgement as typeAcknowledgement} from "./types"
import { RecvPacketResult as typeRecvPacketResult} from "./types"

export { MsgSendPacket, MsgRecvPacket, MsgTimeout, MsgAcknowledgement };

type sendMsgSendPacketParams = {
  value: MsgSendPacket,
  fee?: StdFee,
  memo?: string
};

type sendMsgRecvPacketParams = {
  value: MsgRecvPacket,
  fee?: StdFee,
  memo?: string
};

type sendMsgTimeoutParams = {
  value: MsgTimeout,
  fee?: StdFee,
  memo?: string
};

type sendMsgAcknowledgementParams = {
  value: MsgAcknowledgement,
  fee?: StdFee,
  memo?: string
};


type msgSendPacketParams = {
  value: MsgSendPacket,
};

type msgRecvPacketParams = {
  value: MsgRecvPacket,
};

type msgTimeoutParams = {
  value: MsgTimeout,
};

type msgAcknowledgementParams = {
  value: MsgAcknowledgement,
};


export const registry = new Registry(msgTypes);

type Field = {
	name: string;
	type: unknown;
}
function getStructure(template) {
	const structure: {fields: Field[]} = { fields: [] }
	for (let [key, value] of Object.entries(template)) {
		let field = { name: key, type: typeof value }
		structure.fields.push(field)
	}
	return structure
}
const defaultFee = {
  amount: [],
  gas: "200000",
};

interface TxClientOptions {
  addr: string
	prefix: string
	signer?: OfflineSigner
}

export const txClient = ({ signer, prefix, addr }: TxClientOptions = { addr: "http://localhost:26657", prefix: "cosmos" }) => {

  return {
		
		async sendMsgSendPacket({ value, fee, memo }: sendMsgSendPacketParams): Promise<DeliverTxResponse> {
			if (!signer) {
					throw new Error('TxClient:sendMsgSendPacket: Unable to sign Tx. Signer is not present.')
			}
			try {			
				const { address } = (await signer.getAccounts())[0]; 
				const signingClient = await SigningStargateClient.connectWithSigner(addr,signer,{registry});
				let msg = this.msgSendPacket({ value: MsgSendPacket.fromPartial(value) })
				return await signingClient.signAndBroadcast(address, [msg], fee ? fee : defaultFee, memo)
			} catch (e: any) {
				throw new Error('TxClient:sendMsgSendPacket: Could not broadcast Tx: '+ e.message)
			}
		},
		
		async sendMsgRecvPacket({ value, fee, memo }: sendMsgRecvPacketParams): Promise<DeliverTxResponse> {
			if (!signer) {
					throw new Error('TxClient:sendMsgRecvPacket: Unable to sign Tx. Signer is not present.')
			}
			try {			
				const { address } = (await signer.getAccounts())[0]; 
				const signingClient = await SigningStargateClient.connectWithSigner(addr,signer,{registry});
				let msg = this.msgRecvPacket({ value: MsgRecvPacket.fromPartial(value) })
				return await signingClient.signAndBroadcast(address, [msg], fee ? fee : defaultFee, memo)
			} catch (e: any) {
				throw new Error('TxClient:sendMsgRecvPacket: Could not broadcast Tx: '+ e.message)
			}
		},
		
		async sendMsgTimeout({ value, fee, memo }: sendMsgTimeoutParams): Promise<DeliverTxResponse> {
			if (!signer) {
					throw new Error('TxClient:sendMsgTimeout: Unable to sign Tx. Signer is not present.')
			}
			try {			
				const { address } = (await signer.getAccounts())[0]; 
				const signingClient = await SigningStargateClient.connectWithSigner(addr,signer,{registry});
				let msg = this.msgTimeout({ value: MsgTimeout.fromPartial(value) })
				return await signingClient.signAndBroadcast(address, [msg], fee ? fee : defaultFee, memo)
			} catch (e: any) {
				throw new Error('TxClient:sendMsgTimeout: Could not broadcast Tx: '+ e.message)
			}
		},
		
		async sendMsgAcknowledgement({ value, fee, memo }: sendMsgAcknowledgementParams): Promise<DeliverTxResponse> {
			if (!signer) {
					throw new Error('TxClient:sendMsgAcknowledgement: Unable to sign Tx. Signer is not present.')
			}
			try {			
				const { address } = (await signer.getAccounts())[0]; 
				const signingClient = await SigningStargateClient.connectWithSigner(addr,signer,{registry});
				let msg = this.msgAcknowledgement({ value: MsgAcknowledgement.fromPartial(value) })
				return await signingClient.signAndBroadcast(address, [msg], fee ? fee : defaultFee, memo)
			} catch (e: any) {
				throw new Error('TxClient:sendMsgAcknowledgement: Could not broadcast Tx: '+ e.message)
			}
		},
		
		
		msgSendPacket({ value }: msgSendPacketParams): EncodeObject {
			try {
				return { typeUrl: "/ibc.core.channel.v2.MsgSendPacket", value: MsgSendPacket.fromPartial( value ) }  
			} catch (e: any) {
				throw new Error('TxClient:MsgSendPacket: Could not create message: ' + e.message)
			}
		},
		
		msgRecvPacket({ value }: msgRecvPacketParams): EncodeObject {
			try {
				return { typeUrl: "/ibc.core.channel.v2.MsgRecvPacket", value: MsgRecvPacket.fromPartial( value ) }  
			} catch (e: any) {
				throw new Error('TxClient:MsgRecvPacket: Could not create message: ' + e.message)
			}
		},
		
		msgTimeout({ value }: msgTimeoutParams): EncodeObject {
			try {
				return { typeUrl: "/ibc.core.channel.v2.MsgTimeout", value: MsgTimeout.fromPartial( value ) }  
			} catch (e: any) {
				throw new Error('TxClient:MsgTimeout: Could not create message: ' + e.message)
			}
		},
		
		msgAcknowledgement({ value }: msgAcknowledgementParams): EncodeObject {
			try {
				return { typeUrl: "/ibc.core.channel.v2.MsgAcknowledgement", value: MsgAcknowledgement.fromPartial( value ) }  
			} catch (e: any) {
				throw new Error('TxClient:MsgAcknowledgement: Could not create message: ' + e.message)
			}
		},
		
	}
};

interface QueryClientOptions {
  addr: string
}

export const queryClient = ({ addr: addr }: QueryClientOptions = { addr: "http://localhost:1317" }) => {
  return new Api({ baseURL: addr });
};

class SDKModule {
	public query: ReturnType<typeof queryClient>;
	public tx: ReturnType<typeof txClient>;
	public structure: Record<string,unknown>;
	public registry: Array<[string, GeneratedType]> = [];

	constructor(client: IgniteClient) {		
	
		this.query = queryClient({ addr: client.env.apiURL });		
		this.updateTX(client);
		this.structure =  {
						PacketState: getStructure(typePacketState.fromPartial({})),
						PacketSequence: getStructure(typePacketSequence.fromPartial({})),
						Packet: getStructure(typePacket.fromPartial({})),
						Payload: getStructure(typePayload.fromPartial({})),
						Acknowledgement: getStructure(typeAcknowledgement.fromPartial({})),
						RecvPacketResult: getStructure(typeRecvPacketResult.fromPartial({})),
						
		};
		client.on('signer-changed',(signer) => {			
		 this.updateTX(client);
		})
	}
	updateTX(client: IgniteClient) {
    const methods = txClient({
        signer: client.signer,
        addr: client.env.rpcURL,
        prefix: client.env.prefix ?? "cosmos",
    })
	
    this.tx = methods;
    for (let m in methods) {
        this.tx[m] = methods[m].bind(this.tx);
    }
	}
};

const IgntModule = (test: IgniteClient) => {
	return {
		module: {
			IbcCoreChannelV_2: new SDKModule(test)
		},
		registry: msgTypes
  }
}
export default IgntModule;